var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendInviteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6378 11.8324L10.1373 14.3326M17.8788 6.02439C17.9579 5.9971 18.0431 5.99261 18.1246 6.01143C18.2061 6.03025 18.2807 6.07163 18.3398 6.13082C18.399 6.19002 18.4402 6.26466 18.4589 6.3462C18.4776 6.42774 18.473 6.5129 18.4456 6.59194L13.508 20.7015C13.4784 20.7859 13.4242 20.8594 13.3523 20.9125C13.2805 20.9657 13.1943 20.996 13.105 20.9996C13.0157 21.0032 12.9274 20.9799 12.8515 20.9327C12.7756 20.8855 12.7157 20.8166 12.6795 20.7349L9.99642 14.6993C9.95128 14.599 9.87092 14.5186 9.77054 14.4735L3.73434 11.7899C3.6529 11.7535 3.58424 11.6936 3.53722 11.6178C3.4902 11.5421 3.46699 11.4539 3.47058 11.3648C3.47417 11.2757 3.50439 11.1897 3.55736 11.118C3.61032 11.0462 3.68358 10.992 3.76768 10.9623L17.8788 6.02439Z",
    stroke: "#FFFFFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendInviteIcon);
export default __webpack_public_path__ + "static/media/SendInviteIcon.724d46ebc7e1329b49ebd9af2f68db96.svg";
export { ForwardRef as ReactComponent };